var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluscircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 9.99945H9.5M9.5 9.99945H6.125M9.5 9.99945V13.3745M9.5 9.99945L9.5 6.62445M18.5 10C18.5 14.9706 14.4706 19 9.5 19C4.52944 19 0.5 14.9706 0.5 10C0.5 5.02944 4.52944 1 9.5 1C14.4706 1 18.5 5.02944 18.5 10Z",
    stroke: "#265DAF",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluscircle);
export default __webpack_public_path__ + "static/media/pluscircle.bc18014001c05afd8e4a138822e3a6fa.svg";
export { ForwardRef as ReactComponent };